import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 28 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 25\" id=\"star\">\n  <g stroke-width=\"1.34814815\" fill-rule=\"evenodd\">\n    <path d=\"M14.0012093,1.98180705 L10.973851,10.3514934 L2.09745181,10.3514934 L8.64873261,15.0473705 L6.40744958,23.3094938 L14.0011376,17.710916 L21.5948256,23.3094938 L19.3535605,15.0474365 L25.9030407,10.3514934 L17.0284161,10.3514934 L14.0012093,1.98180705 Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol